const Query = props => {
  const { contactsV2 } = props || {};
  const { sqlQuery } = contactsV2 || {};

  return <div>{sqlQuery}</div>;
};

export default Query;
